import { routesPaths } from './routes-paths';

import { i18n } from '../i18n';
import { IRoutePath } from '../types';

export const adminPaths = (productFamilies: string[] = []): IRoutePath[] => [
  {
    path: routesPaths.ADMIN_OVERVIEW,
    name: i18n.t('common.admin-overview'),
    id: 'overview',
  },
  {
    path: '',
    name: i18n.t('common.admin-products'),
    id: 'products',
    children: productFamilies.sort().map((path: string) => ({
      path: routesPaths.ADMIN_PRODUCTS.replace(':productFamily', path),
      name: path,
      id: path,
    })),
  },
  {
    path: routesPaths.ADMIN_SUBSCRIPTIONS,
    name: i18n.t('common.admin-subscriptions'),
    id: 'subscriptions',
  },
  {
    path: routesPaths.ADMIN_PARTNERS,
    name: i18n.t('common.admin-partners'),
    id: 'partners',
  },
  {
    path: routesPaths.ADMIN_EMAIL_VALIDATIONS,
    name: i18n.t('common.admin-email-validations'),
    id: 'email-validations',
  },
  {
    path: routesPaths.ADMIN_ENTERPRISE,
    name: i18n.t('common.admin-enterprise'),
    id: 'enterprise',
  },
  {
    path: routesPaths.ADMIN_CHECKLISTS,
    name: i18n.t('common.admin-checklists'),
    id: 'checklists',
  },
  {
    path: routesPaths.ADMIN_ANNOUNCEMENTS,
    name: i18n.t('common.admin-announcements'),
    id: 'announcements',
  },
];
